(function () {
    'use strict';

    angular
        .module('elogbooks')
        .controller('LoginController', LoginController);

    LoginController.$inject = [
        '$state',
        '$scope',
        '$rootScope',
        '$location',
        'userManager',
        'apiClient',
        'rootResource',
        '$window',
        'stonlyService',
        '$timeout',
        'disableSubmitService',
        'ahaWidgetService',
        '$stateParams',
        'loginService',
        'modulesService'
    ];

    function LoginController(
        $state,
        $scope,
        $rootScope,
        $location,
        userManager,
        apiClient,
        rootResource,
        $window,
        stonlyService,
        $timeout,
        disableSubmitService,
        ahaWidgetService,
        $stateParams,
        loginService,
        modulesService
    ) {
        $rootScope.skipDirtyCheck = true;

        var vm = this;
        vm.usernameError = false;
        vm.ssoLoginEnabled = true;
        vm.returnButton = $rootScope.returnButton || false;
        vm.userTrainingRequired = $rootScope.userTrainingRequired || false;
        vm.forgotPassword = false;

        vm.login = login;
        vm.forgottenPassword = forgottenPassword;
        vm.cancelForgotUsername = cancelForgotUsername;
        vm.back = back;

        // Use shared initialization
        loginService.initVm(vm, rootResource, $stateParams);

        // The password field's `autofocus` attribute doesn't fire here because
        // this page is reached via a ui-router state transition, not a real
        // navigation/parse - browsers only run the autofocus algorithm on the
        // latter. Focus it manually once the view has rendered instead.
        if (!vm.returnButton) {
            $timeout(function() {
                var passwordField = document.getElementsByName('login-password')[0];
                if (passwordField) {
                    passwordField.focus();
                }
            });
        }

        // This state is directly routable (/login/continue?username=), so entry here
        // proves nothing about how the user is meant to authenticate. Re-check.
        loginService.fetchNextHint(vm.credentials.username).then(function (hint) {
            if (hint === 'password') {
                vm.ssoLoginEnabled = false;
                return;
            }

            denyPasswordLogin(hint);
        });

        // shared method binding
        vm.recaptchaSetResponse = (response) => {
            loginService.recaptchaSetResponse(vm, response);
        };
        vm.recaptchaSetWidgetId = (widgetId) => {
            loginService.recaptchaSetWidgetId(vm, widgetId);
        };
        vm.recaptchaSetExpiration = () => {
            loginService.recaptchaSetExpiration(vm);
        };
        vm.toggleLink = (type) => {
            loginService.toggleLink(vm, type);
        };
        vm.returnToLogin = (form) => {
            loginService.returnToLogin(vm, form);
        };

        if ($window.localStorage.getItem('recaptchaRequired')) {
            vm.recaptchaCheck = true;
        }

        var loginResultHandlers = {
            'USER_NEED_EMAIL_VERIFICATION': function() {
                $state.go('email.verification');
            },
            'USER_AUTH_RECAPTCHA_REQUIRED': function() {
                vm.loading = false;
                vm.recaptchaCheck = true;
                $window.localStorage.setItem('recaptchaRequired', true);
            },
            'USER_AUTH_RECAPTCHA_INVALID': function() {
                $rootScope.username = vm.credentials.username;
                vm.recaptchaCheck = true;
                vm.recaptchaSetExpiration();
                vm.loading = false;
            },
            'USER_AUTH_TOO_MANY_ATTEMPTS': handleTooManyAttempts,
            'USER_AUTH_BAD_CREDENTIALS': handleBadCredentials,
            'USER_ACCOUNT_DISABLED': function() {
                vm.returnButton = $rootScope.returnButton = true;
                vm.loading = false;
            },
            'USER_IN_TRAINING': function() {
                vm.loading = false;
                vm.userTrainingRequired = $rootScope.userTrainingRequired = true;
                vm.returnButton = $rootScope.returnButton = true;
            }
        };

        var loginLoadingDeregister = $rootScope.$on('loginLoading', function() {
            $timeout(function() {
                disableSubmitService.enableSubmit()
                vm.loading = false;
            }, 1000);
        });

        $scope.$on('$destroy', function() {
            loginLoadingDeregister();
        });

        function handleBadCredentials() {
            vm.credentials.password = null;
            $rootScope.username = vm.credentials.username;
            if (vm.recaptchaCheck) {
                vm.recaptchaSetExpiration();
            }
            vm.loading = false;
        }

        function handleTooManyAttempts() {
            handleBadCredentials();
            vm.locked = true;
        }

        function handleLoginResult(result) {
            if (result !== true && result !== 'USER_NEED_EMAIL_VERIFICATION') {
                vm.loginFailMsg = $rootScope.loginFailMsg = result;
            }

            var handler = loginResultHandlers[result];
            if (handler) {
                handler();
            } else if (result === true) {
                handleSuccessfulLogin();
            } else {
                vm.loading = false;
                vm.loginFailMsg = $rootScope.loginFailMsg = 'USER_AUTH_FAIL';
            }
        }

        function handleSuccessfulLogin() {
            $window.localStorage.removeItem('recaptchaRequired');
            $window.localStorage.removeItem('userEmail');
            loginService.rememberUsername(vm.credentials.username);

            userManager.getUser().then(function(user) {
                $rootScope.skipDirtyCheck = false;

                if ($state.params.destination) {
                    //TODO CAFM-1862
                    $location.url($state.params.destination.decode());
                } else if (userManager.hasPermission("site_permission_helpdesk") &&
                           !userManager.hasPermission("user_permission_manage_users")) {
                    var targetState = modulesService.isEnabled('quotes')
                        ? 'dashboard.helpdesk.dashboard.quotes.chase'
                        : 'dashboard.helpdesk.dashboard.reactive-jobs.chase';
                    $state.go(targetState).then(function() {
                        $rootScope.username = null;
                    });
                } else {
                    $state.go('dashboard.user.dashboard').then(function() {
                        $rootScope.username = null;
                    });
                }
            });
        }

        // Sends the user back to step 1 rather than POSTing a password. `hint` is
        // 'sso' when SSO is required, or null when /sso/next-hint couldn't be read.
        function denyPasswordLogin(hint) {
            vm.credentials.password = null;
            vm.ssoLoginEnabled = true;
            vm.loading = false;
            $rootScope.loginFailMsg = hint === 'sso'
                ? 'USER_AUTH_SSO_LOGIN_REQUIRED'
                : 'SSO_NEXT_HINT_UNAVAILABLE';

            $state.go('login.step1', {
                username: vm.credentials.username,
                destination: $stateParams.destination
            });
        }

        // The SSO gate for web. The backend's USER_AUTH_SSO_LOGIN_REQUIRED block is
        // being softened so the legacy app can keep using POST /api/login,
        // which leaves this the only thing stopping an SSO user completing a
        // password login on web.
        //
        // Keyed on vm.credentials.username (what is actually submitted), not on the
        // hint fetched at page load: those differ if the username is changed after
        // entry, and the load-time check would pass while this POST bypassed SSO.
        function login() {
            vm.loading = true;
            vm.loginFailMsg = $rootScope.loginFailMsg = null;

            loginService.fetchNextHint(vm.credentials.username).then(function (hint) {
                if (hint !== 'password') {
                    denyPasswordLogin(hint);
                    return;
                }

                stonlyService.init();
                ahaWidgetService.resetToken();

                if (vm.recaptchaCheck) {
                    vm.credentials.recaptchaResponse = vm.recaptchaResponse;
                }

                userManager.login(vm.credentials).then(handleLoginResult);
            });
        }

        function forgottenPassword() {
            vm.loginFailMsg = null;
            $rootScope.loginFailMsg = null;
            vm.loading = true;

            apiClient.create(rootResource.getLink('passwordchangerequests'), {
                username: vm.credentials.username
            }).then(function (response) {
                if (response) {
                    vm.loading = false;
                    vm.passwordRequestSubmitted = true;
                } else {
                    vm.loading = false;
                }
            });
        }

        function cancelForgotUsername(form) {
            vm.forgotUsername = !vm.forgotUsername;
            vm.email = vm.loginFailMsg = $rootScope.loginFailMsg = vm.usernameError = null;
            vm.locked = false;
            form.$setPristine();
        }

        function back() {
            vm.loginFailMsg = $rootScope.loginFailMsg = null;
            vm.locked = false;
            $state.go('login.step1', {
                username: vm.credentials.username,
                destination: $stateParams.destination
            });
        };
    }
})();
